import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<
    {
        locationSearchText?: string;
        searchRadius?: number;
    }
>;

export const xDispatchUpdateSearchTextField: HandlerType = props => {
    props.dispatch({
        ...props.parameter,
        type: "xLocationFinder/updateLocationFinderSeqarchField",
    } as any);
};

export const chain = [xDispatchUpdateSearchTextField];

const xUpdateSearchTextField = createHandlerChainRunner(chain, "XUpdateSearchTextField");
export default xUpdateSearchTextField;
